import { Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import React from 'react';

import { UppyFeatureFlagWrapper } from '@components/common/uppy/UppyFeatureFlagWrapper';
import { structureUppyAttachments } from '@helpers/uploaders';
import {
  uniqueFilesByKey,
  duplicateSweetAlertOptions,
  formattedUppyAttachments,
  getUniqueKey,
  sanitizeUppyKey,
} from '@helpers/uppy';

class AttachmentUppy extends React.Component {
  triggerUpload = (files) => {
    const uniqueKey = getUniqueKey();
    const uniqFiles = uniqueFilesByKey(files, uniqueKey);
    if (files.length !== uniqFiles.length) {
      window.swal(duplicateSweetAlertOptions, (removeDuplicates) => {
        if (removeDuplicates) {
          this.stageAttachmentForUpload(formattedUppyAttachments(uniqFiles));
        } else {
          this.stageAttachmentForUpload(formattedUppyAttachments(files));
        }
      });
    } else {
      this.stageAttachmentForUpload(structureUppyAttachments(files));
    }
  }

  stageAttachmentForUpload = (attachments) => {
    const { assetKey, onUpload } = this.props;

    onUpload(attachments);
    Insight.createEvent('added_attachments', assetKey, 'asset');
  }

  trigger = () => `uppy-asset-upload-trigger-${sanitizeUppyKey(this.props.assetKey)}`

  renderArea() {
    return (
      <div className="uppy-attachment-area" id={this.trigger()}>
        <p><Trans>Click to add an attachment</Trans></p>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderArea()}
        <UppyFeatureFlagWrapper
          {...this.props}
          button
          handleUpload={this.triggerUpload}
          trigger={`#${this.trigger()}`}
          uniqIdentifier={`attachment-uppy-${sanitizeUppyKey(this.props.assetKey)}`}
        />
      </React.Fragment>
    );
  }
}

AttachmentUppy.propTypes = {
  assetKey: PropTypes.string.isRequired,
  onUpload: PropTypes.func.isRequired
};

export default AttachmentUppy;
